import { useContext, useState } from "react";
import "../../../../styles/workspace_styles/TenantAdministratorStyles/Accounts/Security.css";
import { AppContext } from "../../../AppProvider";
import JwtDecodeService from "../../../../services/JwtDecodeService";
import { LoadShortDate } from "../../../../functions/LoadShortDate";
import { LoadShortTime } from "../../../../functions/LoadShortTime";
import { usersMicroserviceUrl } from "../../../../microservices/users_microservice";
import { Eye, EyeOff } from "lucide-react";
const Security = () =>{
    const {user,logout,setShowBottomRightMessageBox,setBottomRightMessageBoxMessage} = useContext(AppContext);
    const [showCurrentPassword,setShowCurrentPassword] = useState(false);
    const [showNewPassword,setShowNewPassword] = useState(false);
    const [showConfirmNewPassword,setShowConfirmNewPassword] = useState(false);
    const [currentPasswordEntry,setCurrentPasswordEntry] = useState('');
    const [newPasswordEntry,setNewPasswordEntry] = useState('');
    const [confirmNewPasswordEntry,setConfirmNewPasswordEntry] = useState('');
    const [changePasswordErrorMessage,setChangePasswordErrorMessage] = useState('');
    const [changingPassword,setChangingPassword] = useState(null);
    const changeAccountPassword = async() =>{
        setChangingPassword('changing');
        try{
            const payload = {
                currentPassword:currentPasswordEntry,
                newPassword:newPasswordEntry
            };
            const url = `${usersMicroserviceUrl}/passwords`;
            const response = await fetch(url,{
                method:'PATCH',
                headers:{
                    'Authorization':`Bearer ${user?.access_token}`,
                    'Content-Type':'application/json'
                },
                body:JSON.stringify(payload)
            });
            if(response.ok) setChangingPassword('changed');
            else if(response.status === 401) logout();
            else if(response.status === 403) setChangingPassword('forbidden');
            else setChangingPassword('error');
        }
        catch(error){
            console.error('Unexpected error occurred when updating user password',error);
            setChangingPassword('error');
        }
    };
    const getTokenExpiryDate = () =>{
        const decodedToken = JwtDecodeService(user?.access_token);
        return `${LoadShortDate(decodedToken?.exp * 1000)} at ${LoadShortTime(decodedToken?.exp * 1000)}`;
    };
    const showCopyNotification = () =>{
        setBottomRightMessageBoxMessage("Your account access token has been copied to clipboard");
        setShowBottomRightMessageBox(true);
    };
    const showPrintNotification = () =>{
        setBottomRightMessageBoxMessage("Your account access token has been printed on the console");
        setShowBottomRightMessageBox(true);
    };
    const copyAccessTokenToClipboard = () =>{
        if(navigator.clipboard){
            navigator.clipboard.writeText(user?.access_token);
            showCopyNotification();
        }
        else{
            console.log(user?.access_token);
            showPrintNotification();
        }
    };
    const discardPasswordChanges = () =>{
        setCurrentPasswordEntry('');
        setNewPasswordEntry('');
        setConfirmNewPasswordEntry('');
    };
    return(
        <div className="tenant-administrator-account-security-container">
            <div className="tenant-administrator-account-security-token-container">
                <h2>JWT token</h2>
                <div>
                    <p>Token is valid till {getTokenExpiryDate()}</p>
                    <button onClick={() => copyAccessTokenToClipboard()}>Copy JWT token</button>
                </div>
            </div>
            <div className="tenant-administrator-account-security-password-change-container">
                <div className="tenant-administrator-account-security-password-change-entries-container">
                    <h2>Change Password</h2>
                    <div className="tenant-administrator-account-security-password-change-entry-container">
                        <p>Current password<span>*</span></p>
                        <div>
                            <input
                                type={showCurrentPassword? 'text':'password'}
                                value={currentPasswordEntry}
                                onChange={(e) => setCurrentPasswordEntry(e.target.value)}
                            />
                            <button onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                                title={showCurrentPassword? 'Hide password':'Show password'}>
                                {showCurrentPassword? <EyeOff/>:<Eye/>}
                            </button>
                        </div>
                    </div>
                    <div className="tenant-administrator-account-security-password-change-entry-container">
                        <p>New password<span>*</span></p>
                        <div>
                            <input
                                type={showNewPassword? 'text':'password'}
                                value={newPasswordEntry}
                                onChange={(e) => setNewPasswordEntry(e.target.value)}
                            />
                            <button onClick={() => setShowNewPassword(!showNewPassword)}
                                title={showNewPassword? 'Hide password':'Show password'}>
                                {showNewPassword? <EyeOff/>:<Eye/>}
                                </button>
                        </div>
                    </div>
                    <div className="tenant-administrator-account-security-password-change-entry-container">
                        <p>Confirm new password<span>*</span></p>
                        <div>
                            <input
                                type={showConfirmNewPassword? 'text':'password'}
                                value={confirmNewPasswordEntry}
                                onChange={(e) => setConfirmNewPasswordEntry(e.target.value)}
                            />
                            <button onClick={() => setShowConfirmNewPassword(!showConfirmNewPassword)}
                                title={showConfirmNewPassword? 'Hide password':'Show password'}>
                                {showConfirmNewPassword? <EyeOff/>:<Eye/>}
                            </button>
                        </div>
                    </div>
                </div>
                <div className="tenant-administrator-account-security-password-change-requirements-container">
                    <h2>Password requirements</h2>
                    <div>
                        <h3>At least:</h3>
                        {newPasswordEntry.length < 6?
                            (<ul>
                                <li>6 characters</li>
                            </ul>):(
                                <p><span>&#10003;</span>6 characters</p>
                            )
                        }
                    </div>
                    <div>
                        <h3>At most:</h3>
                        {newPasswordEntry.length < 1 || newPasswordEntry.length > 64?
                            (<ul>
                                <li>64 characters</li>
                            </ul>):(
                                <p><span>&#10003;</span>64 characters</p>
                            )
                        }
                    </div>
                </div>
                <div className="tenant-administrator-account-security-password-change-buttons">
                    <button onClick={() => discardPasswordChanges()}>Discard changes</button>
                    <button onClick={async() =>{
                        if(currentPasswordEntry.length < 1){
                            setChangePasswordErrorMessage('Current password cannot be blank');
                            return;
                        }
                        if(newPasswordEntry.length < 6 || newPasswordEntry.length > 64){;
                            setChangePasswordErrorMessage("New password doesn't meet the requirements");
                            return;
                        }
                        if(newPasswordEntry !== confirmNewPasswordEntry){
                            setChangePasswordErrorMessage('New password does not match the confirmed');
                            return;
                        }
                        await changeAccountPassword();
                    }}>Change Password</button>
                </div>
                {
                    changePasswordErrorMessage.length > 0?
                    (
                        <div className="customer-user-account-security-password-change-error-parent-container">
                            <div className="customer-user-account-security-password-change-error-container">
                                <p>{changePasswordErrorMessage}</p>
                                <div>
                                    <button onClick={() => setChangePasswordErrorMessage('')}>Okay</button>
                                </div>
                            </div>
                        </div>
                    ):(<></>)
                }
                {   changingPassword === 'changing'? 
                    (
                        <div className="tenant-administrator-account-security-password-changing-parent-container">
                            <div className="tenant-administrator-account-security-password-changing-container">
                                <div className="tenant-administrator-account-security-password-changing-container-spinner"></div>
                                <p>Changing password. Please wait...</p>
                            </div>
                        </div>
                    ):changingPassword === 'changed'?
                    (
                        <div className="tenant-administrator-account-security-password-changed-parent-container">
                            <div className="tenant-administrator-account-security-password-changed-container">
                                <h1>Password Updated</h1>
                                <p>Your password has been updated successfully.</p>
                                <div>
                                    <button onClick={() =>{
                                        discardPasswordChanges();
                                        setChangingPassword(null);
                                    }}>Okay</button>
                                </div>
                            </div>
                        </div>
                    ):changingPassword === 'forbidden'?
                    (
                        <div className="tenant-administrator-account-security-password-change-forbidden-parent-container">
                            <div className="tenant-administrator-account-security-password-change-forbidden-container">
                                <h1>Invalid Current Password</h1>
                                <p>The password you entered does not match the current one.<br/> Please check and try again.</p>
                                <div>
                                    <button onClick={() => setChangingPassword(null)}>Okay</button>
                                </div>
                            </div>
                        </div>
                    ):changingPassword === 'error'?
                    (
                        <div className="tenant-administrator-account-security-password-change-error-parent-container">
                            <div className="tenant-administrator-account-security-password-change-error-container">
                                <h1>Something Went Wrong</h1>
                                <p>Unexpected error occurred when updating your password.<br/>Please try again later.</p>
                                <div>
                                    <button onClick={() => setChangingPassword(null)}>Okay</button>
                                </div>
                            </div>
                        </div>
                    ):
                    (<></>)
                }
            </div>
        </div>
    );
};
export default Security;